import * as React from "react";

import './JoinLiveButtonBox.pcss';
import {BundleData, IBundle} from "../../data/BundleData";
import {observer} from "mobx-react";
import {IBundleRegistration} from "../../data/entities/IUser";
import {LiveBadge} from "./LiveBadge";

export const JoinLiveButtonBox = observer((props:{ bundle:IBundle, zoomRegistration:IBundleRegistration } ) => {
  const niceType = BundleData.niceTypeForBundleType(props.bundle.type);
  const joinLive = () => { window.open(props.zoomRegistration.url, '_blank'); }

  return (
    <div className={"join-live-button-box"}>
      <div>
        <div className={"join-live-button"} role={"button"} onClick={joinLive}>
          <span className={"text"}>Join {niceType}</span>
          <span className="material-icons">open_in_new</span>
        </div>
        <div className={'jl-live-badge'}>
          <LiveBadge />
        </div>
      </div>
    </div>
  );

});
